import { useState } from "react"

export const useWorkflowDictionaryFormHandling = () => {

    const [formData,setFormData] = useState({
        code: "",
        name: "",
        gProductId: "",
        iRegistryId: "",
        workflowCategoryId: "",
        description: "",
        version: "",
        effectiveFrom: "",
        effectiveTo: "",
        isActive: true,

        codeStatus: "unchecked",
        nameStatus: "unchecked",
        gProductIdStatus: "unchecked",
        iRegistryIdStatus: "unchecked",
        workflowCategoryIdStatus: "unchecked",
        descriptionStatus: "unchecked",
        versionStatus: "unchecked",
        effectiveFromStatus: "unchecked",
        effectiveToStatus: "unchecked",
    });    

    const handleChange = (event,selectEvent) => {
        let formState ={...formData};

        if(event?.target === undefined && selectEvent){
            switch(selectEvent.name){
                
                case "gInsurer": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,70})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";
                    
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "gLobId": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,170})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }   

                case "gProductId": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,170})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }   

                case "gSubProductId": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,170})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }   

                case "gVehicleCategoryId": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,170})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }
                    
                default: {
                    
                    formState[selectEvent.name] = event;
                    formState[selectEvent.name + "Status"] = event ? "success" : "unchecked";
                    break;
                }
            }
            
            formState[selectEvent.name] = event;
        }
        else if(event && event.target){
            switch(event.target.name){
                case "environment": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,100})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "integrationStatus": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,100})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "onboardedAt": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,20})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "notes": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,20})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }
                default: {

                    formState[event.target.name] = event.target.value;
                    formState[event.target.name + "Status"] =
                    event.target.value === "" ? "unchecked" : "success";
                    break;
                }
            }
            formState[event.target.name] = event.target.value;
        }
        setFormData(formState);
    
    }

    const checkAllFields = () => {
        let allowSubmit = false;

        if (
        formData.codeStatus === "success" &&
        formData.nameStatus === "success" &&
        formData.iRegistryIdStatus === "success" &&
        formData.gProductIdStatus === "success" &&
        formData.workflowCategoryIdStatus === "success"
        ) {
        allowSubmit = true;
        } else {
        allowSubmit = false;
        }

        return allowSubmit;
    };

    return{
        formData,
        setFormData,
        handleChange,
        checkAllFields
    }
}